import script from "./AdventureChatMessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatMessageList.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatMessageList.vue?vue&type=style&index=0&id=781e1fea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781e1fea"]])

export default __exports__